import challengeConstants from '../actiontypes/challenge';
import appModalActions from './appModal.action';
import { getChallenge, validatePassword, getSMSchallenge, validateSMS } from '../../api/ChallengeService';

function getChallenges(id) {
  return dispatch => {
    dispatch({ type: challengeConstants.CHALLENGE_REQUEST });

    dispatch(appModalActions.loadingOn('Obteniendo Información de Seguridad'));

    getChallenge(id)
      .then(
        response => {
          dispatch({
            type: challengeConstants.CHALLENGE_REQUEST_SUCCESS,
            payload: response.data
          });
        },
        (error) => {
          dispatch({
            type: challengeConstants.CHALLENGE_REQUEST_FAILURE
          });
          
          dispatch(
            appModalActions.openErrorModal(error.data.mensaje)
          );
        }
      )
      .then(() => {
        dispatch(appModalActions.loadingOff());
      });
  };
}

function closeChallenge() {
  return {
    type: challengeConstants.CHALLENGE_CLOSED
  };
}

function changeChallengeResponse(value) {
  return {
    type: challengeConstants.CHALLENGE_RESPONSE_CHANGED,
    payload: value
  };
}

function changeSMSChallengeResponse(smscode) {
  return {
    type: challengeConstants.CHALLENGE_RESPONSE_CHANGED,
    payload: smscode
  };
}

function validateChallenge(password) {
  return dispatch => {
    dispatch({ type: challengeConstants.CHALLENGE_VALIDATE });
    setTimeout(()=>{
      validatePassword(password).then(
        response => {
          dispatch({
            type: challengeConstants.CHALLENGE_VALIDATE_SUCCESS,
            payload: response.data
          });
        },
        error => {
          dispatch({
            type: challengeConstants.CHALLENGE_VALIDATE_FAILURE,
            payload: error
          });
          dispatch({type: challengeConstants.CHALLENGE_CLOSED});
          dispatch(
            appModalActions.openErrorModal(error.data.mensaje)
          );
        }
      );
    },1000);
    
  };
}

function getSMSChallenge(){
  return dispatch => {
    //dispatch({ type: challengeConstants.CHALLENGE_REQUEST });
    getSMSchallenge().then(() => {
      dispatch({
        type: challengeConstants.CHALLENGE_REQUEST_SMS_SUCCESS,
      });

    },(error) => {
      dispatch({
        type: challengeConstants.CHALLENGE_REQUEST_SMS_FAILURE
      });
      dispatch({type: challengeConstants.CHALLENGE_CLOSED});
      dispatch(
        appModalActions.openErrorModal(error.data.mensaje)
      );

    });
  };
}

function validateSMSChallenge(smscode){
  return dispatch => {
    dispatch({ type: challengeConstants.CHALLENGE_VALIDATE });
    validateSMS(smscode).then(response => {
      dispatch({
        type: challengeConstants.CHALLENGE_VALIDATE_SMS_SUCCESS,
        payload: response.data


      });
    }, (error)=>{
      dispatch({
        type: challengeConstants.CHALLENGE_VALIDATE_FAILURE,
        payload: error
      });
      dispatch({type: challengeConstants.CHALLENGE_CLOSED});
      dispatch(
        appModalActions.openErrorModal(error.data.mensaje)
      );
    });
  }
}

function removeError() {
  return {
    type: challengeConstants.CHALLENGE_INVALID
  };
}

function changeErrorMessage(message) {
  return {
    type: challengeConstants.CHALLENGE_ERROR_MESSAGE_CHANGED,
    payload: message
  }
}

const challengeActions = {
  getChallenges,
  closeChallenge,
  changeChallengeResponse,
  validateChallenge,
  getSMSChallenge,
  validateSMSChallenge,
  changeSMSChallengeResponse,
  removeError,
  changeErrorMessage
};

export default challengeActions;
